import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import TitleRow, { TitleAction } from "../../../../shared/components/TitleRow";
import { ROLE } from "../../../../data/enums";
import CancelModal from "../../../../shared/components/CancelModal";
import { WarningKpiModal } from "../../../../configs/kpi";

interface TitleProps {
    title: string;
    setValidate: any;
    createTitleButtonText: any;
    submitForm: Function;
    onDataChange?: () => void;
    hasUnsavedChanges?: boolean;
    onCancelClick?: () => void;
    isLoading?: boolean;
}

const Title = ({
                   title,
                   setValidate,
                   createTitleButtonText,
                   submitForm,
                   onDataChange,
                   hasUnsavedChanges,
                   onCancelClick,
                   isLoading = false,
               }: TitleProps) => {
    const navigate = useNavigate();
    const [showCancelModal, setShowCancelModal] = useState(false);
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const handleCancel = () => {
        if (onDataChange) {
            onDataChange();
        }

        if (onCancelClick && hasUnsavedChanges) {
            onCancelClick();
        } else {
            setShowCancelModal(true);
        }
    };
    const handleConfirmCancel = () => {
        setShowCancelModal(false);
        navigate(createTitleButtonText.url);
    };

    const titleActions: TitleAction[] = [
        {
            title: createTitleButtonText.cancelButton,
            onClick: () => handleCancel(),
        },
        {
            title: createTitleButtonText.addButton,
            variant: "contained",
            isLoading,
            onClick: () => {
                if (isLoading) return;
                setValidate(true);
                submitForm();
            },
        },
    ];

    const getTitleActions = () => {
        switch (role) {
            case ROLE.STORAGE_KEEPER:
            case ROLE.FIRST_STORAGE_KEEPER:
            case ROLE.SECOND_STORAGE_KEEPER:
            case ROLE.DELIVERER:
            case ROLE.SALE_MANAGER:
            case ROLE.SALE_STAFF:
            case ROLE.LOGISTIC_MANAGER:
            case ROLE.LOGISTIC_STAFF:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
            case ROLE.FACTORY_STAFF:
            case ROLE.FACTORY_MANAGER_ONE:
            case ROLE.FACTORY_MANAGER_TWO:
            case ROLE.DEPUTY_FACTORY_MANAGER_ONE:
            case ROLE.DEPUTY_FACTORY_MANAGER_TWO:
                return titleActions;
            default:
                return titleActions;
        }
    };
    return (
        <>
            <TitleRow title={title} actions={getTitleActions()} />
            {showCancelModal && (
                <CancelModal
                    title={WarningKpiModal.title}
                    contentText={WarningKpiModal.context}
                    open={showCancelModal}
                    handleClose={() => setShowCancelModal(false)}
                    handleConfirm={handleConfirmCancel}
                />
            )}
        </>
    );
};

export default Title;
